import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { IQuestion } from '../../../../interfaces/question.interface';

@Component({
  selector: 'app-image-answer',
  templateUrl: './image-answer.component.html',
  styleUrls: ['./image-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ImageAnswerComponent {
  @Input() question: IQuestion;
  @Input() count: number | null = null;
  @Input() withComment = false;
  form = this.fb.group({
    value: null,
  });
  constructor(private fb: UntypedFormBuilder) {}
}
